<script lang="ts">
  import {deleteDiff} from "$lib/services/MasterdataService";

  const {diffId, sourceSystem, originatingEnv, onCancelled}: {
    diffId: string | undefined;
    sourceSystem: string;
    originatingEnv: string;
    onCancelled?: () => void;
  } = $props();

  let isDeleting = $state(false);

  async function handleSubmit(e: Event) {
    e.preventDefault();
    if (!diffId || !sourceSystem) return;
    isDeleting = true;
    const success = await deleteDiff(sourceSystem, diffId, originatingEnv);
    if (success) {
      onCancelled?.();
      if (e.currentTarget instanceof HTMLFormElement) {
        e.currentTarget.dispatchEvent(new CustomEvent('cancelled', {bubbles: true, composed: true}));
      }
    }
    isDeleting = false
  }
</script>

{#if diffId}
  <form onsubmit={handleSubmit}>
    <button type="submit" class="btn btn-primary-light" disabled={isDeleting}>
      {isDeleting ? 'Cancelling…' : 'Cancel'}
    </button>
  </form>
{/if}
